import { render, staticRenderFns } from "./ModalForgot.vue?vue&type=template&id=4d5d46fc&scoped=true&"
import script from "./ModalForgot.vue?vue&type=script&lang=js&"
export * from "./ModalForgot.vue?vue&type=script&lang=js&"
import style0 from "./ModalForgot.vue?vue&type=style&index=0&id=4d5d46fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d46fc",
  null
  
)

export default component.exports